package com.essntl.features.tag.ui.addedittag

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import com.essntl.uikit.components.button.destructive.EsLargeDestructiveButton
import com.essntl.uikit.components.button.primary.EsLargePrimaryButton
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.input.EsInput
import com.essntl.uikit.components.spinner.EsSpinner
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography
import core.validation.EsInputState

@Composable
fun AddEditTagScreen(
    state: AddEditTagState,
    validation: AddEditTagValidation,
    onEvent: (AddEditTagEvent) -> Unit,
) {
    val isEdit by remember(state.tag.value.id) {
        mutableStateOf(
            state.tag.value.id.isNotBlank(),
        )
    }

    var isEditEnabled by remember(state.getTag.data?.id) { mutableStateOf(false) }

    LaunchedEffect(state.addEditTag.isSuccess) {
        if (state.addEditTag.isSuccess) {
            isEditEnabled = false
        }
    }

    LaunchedEffect(state.getTag.data) {
        validation.addEditTagForm.reset()
        validation.addEditTagForm.name.value = state.getTag.data?.name.orEmpty()
    }

    LazyColumn(
        verticalArrangement = Arrangement.Center,
        horizontalAlignment = Alignment.CenterHorizontally,
        modifier = Modifier
            .fillMaxSize()
            .clip(
                RoundedCornerShape(
                    topStart = 24.dp,
                    topEnd = 24.dp,
                ),
            )
            .padding(
                horizontal = 2.5f.spacing,
            ),
    ) {
        if (
            state.getTag.isLoading ||
            state.getTag.isFailure ||
            (isEdit && state.getTag.data == null)
        )
            item {
                Box(
                    contentAlignment = Alignment.Center,
                    modifier =
                        Modifier
                            .fillMaxWidth()
                            .height(200.dp)
                            .padding(2.5f.spacing)
                            .clip(RoundedCornerShape(EsConstants.RoundedCornerSize)),
                ) {
                    if (state.getTag.isLoading)
                        EsSpinner()
                    else
                        Text(
                            text = "Something goes wrong!",
                            color = MaterialTheme.esColorScheme.textSecondary,
                            style = MaterialTheme.esTypography.p1Medium16,
                        )
                }
            }
        else {
            item {
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                ) {
                    EsInput(
                        value = state.tag.value.name,
                        state = if (!state.addEditTag.errorMessage.isNullOrEmpty())
                            EsInputState.Error else
                            validation.addEditTagForm.name.state,
                        onValueChange = {
                            validation.addEditTagForm.name.validate(it)
                            onEvent(
                                AddEditTagEvent.UpdateTagFields(
                                    state.tag.value.copy(
                                        name = it,
                                    ),
                                ),
                            )
                        },
                        label = "Title",
                        placeholder = "Enter title",
                        message = state.addEditTag.errorMessage
                            .orEmpty()
                            .ifEmpty { "This field is required" },
                        enabled = if (isEdit) isEditEnabled else true,
                        modifier = Modifier.weight(1f),
                    )
                }
            }

            item {
                Spacer(modifier = Modifier.height(3.spacing))

                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.spacedBy(1.spacing),
                    modifier = Modifier.fillMaxWidth(),
                ) {
                    if (isEdit)
                        EsLargeDestructiveButton(
                            onClick = {
                                onEvent(AddEditTagEvent.DeleteTag)
                            },
                            text = "Delete Tag",
                            suffixIconRes = EsIcons.Trash,
                            loading = state.deleteTag.isLoading,
                            modifier = Modifier.weight(1f),
                        )

                    EsLargePrimaryButton(
                        onClick = {
                            if (isEdit && !isEditEnabled) {
                                isEditEnabled = true
                            } else if (validation.addEditTagForm.validate()) {
                                if (isEdit) {
                                    onEvent(AddEditTagEvent.EditTag)
                                } else {
                                    println("Add Tag")
                                }
                            }
                        },
                        text =
                            if (isEdit) {
                                if (isEditEnabled) {
                                    "Update"
                                } else {
                                    "Edit"
                                }
                            } else {
                                "Save Tag"
                            },
                        loading = state.addEditTag.isLoading,
                        enabled = if (isEditEnabled) state.isEditEnabled else true,
                        modifier = Modifier.weight(1f),
                    )
                }
            }
        }
    }
}